import type { AddressCreateDto, AddressResponseDto, AddressUpdateDto } from "@/types/address.dto";
import type { ApiResponse } from "@/types/common";
import { apiClient, unwrapApiResponse } from "./httpClient";

export const addressesService = {
  getAll(): Promise<AddressResponseDto[]> {
    return unwrapApiResponse(apiClient.get<ApiResponse<AddressResponseDto[]>>("/Addresses"));
  },

  getById(id: number): Promise<AddressResponseDto> {
    return unwrapApiResponse(apiClient.get<ApiResponse<AddressResponseDto>>(`/Addresses/${id}`));
  },

  create(dto: AddressCreateDto): Promise<AddressResponseDto> {
    return unwrapApiResponse(apiClient.post<ApiResponse<AddressResponseDto>>("/Addresses", dto));
  },

  update(id: number, dto: AddressUpdateDto): Promise<AddressResponseDto> {
    return unwrapApiResponse(apiClient.put<ApiResponse<AddressResponseDto>>(`/Addresses/${id}`, dto));
  },

  delete(id: number): Promise<boolean> {
    return unwrapApiResponse(apiClient.delete<ApiResponse<boolean>>(`/Addresses/${id}`));
  },

  setDefault(id: number): Promise<boolean> {
    return unwrapApiResponse(apiClient.put<ApiResponse<boolean>>(`/Addresses/${id}/default`));
  },
};
